<template>
    <div class="popup" v-show="show">
        <div class="projectDetail bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div v-if="flag==='create'" class="title f18 bold500 txt_black87 tc">新建项目</div>
            <div v-if="flag==='edit'" class="title f18 bold500 txt_black87 tc">编辑项目</div>

            <div class="content">
                <div class="mask w100 h100" v-show="flag==='view'"></div>
                <div class="fl item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        项目名称：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入项目名称" v-model="data.name"/>
                    </div>
                </div>

                <div class="fr item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        项目地址：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入项目地址" v-model="data.address"/>
                    </div>
                </div>

                <div class="fl item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        联系人：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入联系人" v-model="data.contacts"/>
                    </div>
                </div>

                <div class="fr item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        联系人电话：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入联系人电话" v-model="data.phone"/>
                    </div>
                </div>

                <div class="fl item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        合伙人：
                    </div>
                    <div class="ipt">
                        <selection :options="partners" v-model="partner" @change="partnerChange"></selection>
                    </div>
                </div>
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "projectDetail",
        data() {
            return {
                show: false,
                flag: 'create',
                id: null,
                partners: null,
                partner: '',
                data: {
                    name: '',
                    address: '',
                    contacts: '',
                    phone: '',
                    partner: ''
                }
            }
        },
        methods: {
            init(flag,data) {
                this.flag = flag;
                this.show = true;
                for (let v in this.data) {
                    this.data[v] = data[v];
                }
                this.id = data.id;
                this.partner = this.data.partner;
                this.getPartners();
            },
            getPartners() {
                this.$api.get('/manage/partner').then((data) => {
                    this.partners = data.data.map((item) => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取合伙人列表失败'});
                });
            },
            partnerChange(data) {
                this.data.partner = data ?  data.id : '';
            },
            submitEvent() {
                if(this.flag === 'create'){
                    this.$api.post('/manage/project',this.data).then((data) => {
                        this.$alert.success({content: '新建项目成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '新建项目失败，请重试'});
                    });
                }else {
                    this.$api.put('/manage/project/' + this.id,this.data).then((data) => {
                        this.$alert.success({content: '修改成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '修改失败，请重试'});
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .projectDetail {
        width: 600px;
        height: 420px;
    }

    .content {
        padding: 0 20px;
    }

    .content > .item {
        margin-top: 15px;
        width: 250px;
    }

    .content > .item > div:nth-of-type(2)>:first-child{
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > .item > .ipt > input {
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        padding: 0 10px;
    }

    .submit {
        margin-top: 250px;
    }
</style>